export default {"src":"/_next/static/media/AcuteKidneyLiverFailure.d19d93b7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};